<template>
  <div
    style="
      width: 100%;
      max-height: 315px;
      padding: 0 0.75rem;
      border: 1px solid #bdccdc;
      border-radius: 0.25rem;
    "
  >
    <skeleton width="98%" height="100px" />
    <skeleton width="100%" height="5px" />
    <skeleton width="30%" height="5px" />
    <skeleton width="50%" height="5px" />
    <skeleton width="75%" height="5px" />
    <skeleton width="60%" height="5px" />
  </div>
</template>

<script>
import Skeleton from "../../../common/table/Skeleton.vue";

export default {
  components: { Skeleton },
  name: "MarketProductCardSkeleton",
};
</script>
